import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { getGreeting } from "components/property-banner-image/property-banner-details";
import { TenantPortalPropertyBannerDetails } from "components/property-banner-image/tenant-portal-property-banner-details";
import { useAuth } from "contexts/auth-provider";
import type { OverviewData } from "modules/tenant-portal/models/overview";
import { RequestMaintenanceBox } from "modules/tenant-portal/screens/overview/components/banner-image/request-maintenance-box";

type TenantBannerProps = {
  isLoading: boolean;
  data?: OverviewData;
};
export function TenantBannerImage({ data, isLoading }: TenantBannerProps) {
  const { user } = useAuth();
  const currentHour = new Date().getHours();
  const greeting = getGreeting(currentHour);
  const agencyLogo = data?.agency?.display_picture;

  return (
    <TenantPortalPropertyBannerDetails
      isLoading={isLoading}
      title={`${greeting}, ${user?.given_name}!`}
      subtitle={data?.property?.full_address}
      topLeftElement={
        <Flex align={"center"} gap={"2"}>
          {agencyLogo && (
            <Image
              src={agencyLogo}
              alt={data?.agency?.display_name}
              h={"50px"}
            />
          )}
          <Text textStyle={"xl"} textTransform={"uppercase"}>
            {data?.agency?.display_name}
          </Text>
        </Flex>
      }
      rightElement={
        <Box alignSelf={"stretch"} flex={1} flexBasis={{ base: "100%", xl: 0 }}>
          <RequestMaintenanceBox />
        </Box>
      }
    />
  );
}
